import { render } from "./AgentTable.vue?vue&type=template&id=1b3a35bc&scoped=true"
import script from "./AgentTable.vue?vue&type=script&lang=js"
export * from "./AgentTable.vue?vue&type=script&lang=js"

import "./AgentTable.vue?vue&type=style&index=0&id=1b3a35bc&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3a35bc"]])

export default __exports__